import React, {lazy} from 'react'




const TeamIntegrationsRoot = lazy(
  () =>
    import(
      /* webpackChunkName: 'TeamIntegrationsRoot' */ '../../containers/TeamIntegrationsRoot/TeamIntegrationsRoot'
    )
)

const TeamDashIntegrationsTab = (props) => {
  const {teamRef} = props
  return (
    React.createElement('div', { className: "flex w-full flex-wrap px-4"   ,}
      , React.createElement('div', { className: "m-0",}
        , React.createElement(TeamIntegrationsRoot, { teamId: teamRef,} )
      )
    )
  )
}
export default TeamDashIntegrationsTab
